window.app = window.app || {};
app.site = app.site || {};

app.site.controls = {
    fullstop: () => {
        app.site.controls.stop(document);
    },
    stop: (target) => {
        target.querySelectorAll('video, audio').forEach(media => {
            media.pause();
        });
    }
};

